
import React, {useState, useEffect} from "react"
import styled from "styled-components"
import { Button, Close } from "../UI"

const NotiCard = styled.div`
    border: 1px solid #fff;
    background-color: #fff;
    color: #000;
    border-radius: 10px;
    box-shadow: 0px 7px 7px #0000000a;
    padding: 15px;
    width: 350px;
    line-height: 25px;
    font-size: 16px;
    font-weight: 100;
    z-index: 1000;
    position: fixed;
    top: 12%;
    right: 2%;
    display: none;

    &.visible {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .icon {
        border-radius: 50%;
        width: 50px;
        height: 50px;
        // background: #EFEFEF;
    }
    .info {
        margin: 0px;
    }
    .action {
        width: 50px
        height: 50px;
    }
`


export default function Notification({ ...props }) {
    return (
        <NotiCard className={props.visible ? "visible": ""}>
            <div className="icon">
            <svg width={50} height={50} xmlns="http://www.w3.org/2000/svg" {...props}>
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={50}
                height={50}
                viewBox="0 0 512 512"
                {...props}
                >
                <path
                    d="M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm-32.1 281.7c-2.4 2.4-5.8 4.4-8.8 4.4s-6.4-2.1-8.9-4.5l-56-56 17.8-17.8 47.2 47.2L340 177.3l17.5 18.1-133.6 134.3z"
                    fill="#22c183"
                    className="color000 svgShape"
                />
                </svg>
            </svg>
            </div>
            <div className="info">
                <p>{props.message}</p>
            </div>
            <div className="action">
                <Close className="size-s" onClick={props.trigger}>&#10005;</Close>
            </div>
        </NotiCard>
    )
}